// extracted by mini-css-extract-plugin
export default {"switchInvoiceTable":"invoices_switchInvoiceTable__ojP8L","invoiceOverDue":"invoices_invoiceOverDue__7E3Ut","invoicesPdf":"invoices_invoicesPdf__oE8EM"};